import { useMutation, useQueryClient } from '@tanstack/react-query'
import CattlesApiService from 'services/cattlesApiServices'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export const useTreatmentMutation = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	const invalidateTreatmentQueries = () => {
		queryClient.invalidateQueries({ queryKey: ['treatmentSchemas'] })
		queryClient.invalidateQueries({ queryKey: ['treatmentSchemasOptions'] })
	}

	// Создание схемы лечения
	const createTreatmentSchema = useMutation({
		mutationFn: CattlesApiService.postTreatmentSchema,
		onSuccess: () => {
			invalidateTreatmentQueries()
			dispatch(
				notifyUser({
					title: 'Схема лечения создана',
					description: '',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Попробуйте снова',
					isError: true,
				}),
			)
		},
	})

	const updateTreatmentSchema = useMutation({
		mutationFn: ({
			id,
			data,
		}: {
			id: number
			data: {
				title: string
				description: string
				duration: number
				sickness_id?: number
				sicknesses_id?: number[]
				exam_interval_days?: number
				milk_reject_days?: number | null
			}
		}) => CattlesApiService.patchTreatmentSchema(id, data),
		onSuccess: () => {
			invalidateTreatmentQueries()
			dispatch(
				notifyUser({
					title: 'Успех',
					description: 'Схема лечения успешно изменена',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Ошибка',
					description: 'Не удалось изменить схему лечения',
					isError: true,
				}),
			)
		},
	})

	const deleteTreatmentSchema = useMutation({
		mutationFn: (id: number) => CattlesApiService.deleteTreatmentSchema(id),
		onSuccess: () => {
			invalidateTreatmentQueries()
			dispatch(
				notifyUser({
					title: 'Схема лечения удалена',
					description: '',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Попробуйте снова',
					isError: true,
				}),
			)
		},
	})

	return { createTreatmentSchema, updateTreatmentSchema, deleteTreatmentSchema }
}
